import { render } from "./AddRemoveMultipleItems.vue?vue&type=template&id=36c1416e&scoped=true&ts=true"
import script from "./AddRemoveMultipleItems.vue?vue&type=script&lang=ts"
export * from "./AddRemoveMultipleItems.vue?vue&type=script&lang=ts"

import "./AddRemoveMultipleItems.vue?vue&type=style&index=0&id=36c1416e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c1416e"]])

export default __exports__